import AddDeputies from './AddDeputiesContainer';

export default AddDeputies

